<canvas class="crop-canvas" width="{{width}}" height="{{height}}"></canvas>
